module.exports = __webpack_public_path__ + "img/yellow-share-btn.ec52d7ec.svg";